/**
 * Awvent - Awvent Users API
 * Awvent User Apis
 *
 * OpenAPI spec version: v1
 * Contact: djoyrocks@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { UserDto } from './user.dto';

export class UserUpdateCommand {
    userDetails?: UserDto;
}
